import React from 'react';

const AlertModal = ({ show, title, message, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="jmodal-overlay">
      <div className="jmodal-content">
        <h5 className='fw-bold'>{title}</h5>
        <p>&nbsp;</p>
        <p>{message}</p>
        <div className="d-flex justify-content-end">
          <button className="btn btn-xs btn-primary" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;